"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCtaActionTypePropertyOption = exports.isCtaActionTypeProperty = exports.ctaActionTypePropertyDefinition = void 0;
const defaultCTAActionTypePropertyOptions = [
    'Buy Tickets',
    'Buy Gear',
    'E-Commerce',
    'Register',
    'Read',
    'Listen',
    'Watch',
];
const ctaActionTypePropertyOptions = [
    ...defaultCTAActionTypePropertyOptions,
    'E-reader promotion',
    'Hub index promotion',
    'Subscription promotion',
];
exports.ctaActionTypePropertyDefinition = {
    view: { label: 'Action Type' },
    constraints: [
        {
            name: 'options',
            argument: defaultCTAActionTypePropertyOptions,
        },
    ],
    type: 'select',
    multiple: false,
    name: 'cta-action-type',
};
const isCtaActionTypeProperty = (prop) => {
    return prop.name === exports.ctaActionTypePropertyDefinition.name;
};
exports.isCtaActionTypeProperty = isCtaActionTypeProperty;
const isCtaActionTypePropertyOption = (option) => {
    return ctaActionTypePropertyOptions.includes(option);
};
exports.isCtaActionTypePropertyOption = isCtaActionTypePropertyOption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3RhLWFjdGlvbi10eXBlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvY3RhLWFjdGlvbi10eXBlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLE1BQU0sbUNBQW1DLEdBQUc7SUFDMUMsYUFBYTtJQUNiLFVBQVU7SUFDVixZQUFZO0lBQ1osVUFBVTtJQUNWLE1BQU07SUFDTixRQUFRO0lBQ1IsT0FBTztDQUNDLENBQUE7QUFFVixNQUFNLDRCQUE0QixHQUFHO0lBQ25DLEdBQUcsbUNBQW1DO0lBQ3RDLG9CQUFvQjtJQUNwQixxQkFBcUI7SUFDckIsd0JBQXdCO0NBQ2hCLENBQUE7QUFFRyxRQUFBLCtCQUErQixHQUFHO0lBQzdDLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxhQUFhLEVBQUU7SUFDOUIsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsU0FBUztZQUNmLFFBQVEsRUFBRSxtQ0FBbUM7U0FDOUM7S0FDRjtJQUNELElBQUksRUFBRSxRQUFRO0lBQ2QsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsaUJBQWlCO0NBQ1EsQ0FBQTtBQUkxQixNQUFNLHVCQUF1QixHQUFHLENBQUMsSUFBa0IsRUFBaUMsRUFBRTtJQUMzRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssdUNBQStCLENBQUMsSUFBSSxDQUFBO0FBQzNELENBQUMsQ0FBQTtBQUZZLFFBQUEsdUJBQXVCLDJCQUVuQztBQUlNLE1BQU0sNkJBQTZCLEdBQUcsQ0FBQyxNQUFjLEVBQXlDLEVBQUU7SUFDckcsT0FBUSw0QkFBa0QsQ0FBQyxRQUFRLENBQUMsTUFBTSxDQUFDLENBQUE7QUFDN0UsQ0FBQyxDQUFBO0FBRlksUUFBQSw2QkFBNkIsaUNBRXpDIn0=